import ServicesImageAbstract from "./ServicesImageAbstract";
import Math_ from "../../../../assets/src/js/app/utils/Math";

export default class ServicesImagesMonitoring extends ServicesImageAbstract {
	constructor($wrapper) {
		super($wrapper);
		this.PI2 = Math.PI * 2;
		this.increment = 0.002;

		this.rotation1 = 2;
		this.rotation2 = -2;

		this.startAngle1 = this.PI2 * 0.5;
		this.endAngle1 = this.PI2 * 0.5;
		this.inverted1 = false;

		this.startAngle2 = this.PI2 * 1;
		this.endAngle2 = 0;
		this.inverted2 = true;

		// this.startValue2 = this.PI2 * 0;
		// this.inverted2 = false;
		this.init();
	}

	updateCanvas() {
		const velocity = this.velocity >= 0 ? Math_.clamp(this.velocity * 0.0003, 0.01, 0.1) : Math_.clamp(this.velocity * 0.0003, -0.1, -0.01);
		this.rotation1 += velocity * 0.3;
		this.rotation2 -= velocity * 0.3;
		

		const blue = '#4545FF';

		this.startAngle1 += this.inverted1 === true ? -this.increment : this.increment;
		this.endAngle1 += this.inverted1 === true ? this.increment : -this.increment;

		this.startAngle2 += this.inverted2 === true ? -this.increment : this.increment;
		this.endAngle2 += this.inverted2 === true ? this.increment : -this.increment;

		if ((this.inverted1 === false && this.startAngle1 >= this.PI2) || (this.inverted1 === true && this.startAngle1 <= this.PI2 * 0.5)) {
			this.inverted1 = !this.inverted1;
			this.inverted2 = !this.inverted2;
			this.updateCanvas();
			return;
		}


		// RESET
		this.ctx.resetTransform();
		this.ctx.clearRect(0, 0, this.size, this.size);
		this.ctx.strokeStyle = blue;
		this.ctx.lineCap = 'butt';
		this.ctx.lineWidth = this.size * 0.2;

		// BACKGROUND
		this.ctx.globalAlpha = 0.3;
		this.ctx.beginPath();
		this.ctx.arc(this.size * 0.5, this.size * 0.5, this.size * 0.4, 0, 2 * Math.PI);
		this.ctx.stroke();

		// CIRCLE 1
		this.ctx.globalAlpha = 0.5;
		this.ctx.lineWidth = this.size * 0.1;
		this.ctx.resetTransform();
		this.ctx.translate(this.size * 0.5, this.size * 0.5);
		this.ctx.rotate(this.rotation1);
		this.ctx.beginPath();
		this.ctx.arc(0, 0, this.size * 0.45, this.startAngle1, this.endAngle1, true);
		this.ctx.stroke();

		// CIRCLE 2
		this.ctx.globalAlpha = 1;
		this.ctx.lineWidth = this.size * 0.1;
		this.ctx.resetTransform();
		this.ctx.translate(this.size * 0.5, this.size * 0.5);
		this.ctx.rotate(this.rotation2);
		this.ctx.beginPath();
		this.ctx.arc(0, 0, this.size * 0.35, this.startAngle2, this.endAngle2, true);
		this.ctx.stroke();

	}
}
